var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-loading-screen'),_c('app-header',{attrs:{"promoteInstall":_vm.showInstallButton},on:{"installApp":_vm.installApp}}),_c('app-content'),_c('app-yellow-box'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }